<div class="logo-wrap">
  <img src="{{ src }}" alt="{{ alt }}" width="{{ width }}" height="{{ height }}" class="logo-img">
</div>
